









































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
 

class PageIntegralRequest extends PageRequest {
  Keyword: string;
  //isrent: number; //nullable
  stime: Date;
  etime: Date;
   Disid:number; //区域ID
  Streetid:number;//街道ID
  Comid:number;//社区ID
  Vid:number;//小区ID
  ConsumptionType:number; //操作类型 
  SourceType:number; //积分类型
  Sources:string;  //来源
}

@Component({
  components: {   },
})
export default class Integral extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageIntegralRequest = new PageIntegralRequest();
  creationTime: Date[] = [];
  editModalShow: boolean = false;

  get list() {
    return this.$store.state.integral.list;
  }
  get loading() {
    return this.$store.state.integral.loading;
  }
   
    //获取初始值
      get qarealist(){
          
            return this.$store.state.bhusers.qarea;
     }
      //区下面的街道
       get qarealst(){
           return this.$store.state.bhusers.qarealst;
       }
       set qarealst(val:number){
            this.$store.commit('bhusers/change_qarealst',val);
       }
       //街道的社区
       get sarealst(){
            return this.$store.state.bhusers.sarealst;
       }
       set sarealst(val:number){
          this.$store.commit('bhusers/change_sarealst',val);           
        
       }
       //社区下的小区
      get carealst(){

            return this.$store.state.bhusers.carealst;
       }
       set carealst(val:number){
          this.$store.commit('bhusers/change_carealst',val);           
        
       }
       
     QAreaChange(val:number){
        
       this.pagerequest.Disid=val;
        
     var dt= this.$store.state.bhusers.qarea;
        dt.forEach(item=>{
        if(item.id==val){
         this.qarealst=item;
            }
          })

       }
      SAreaChange(val:number){
       this.pagerequest.Streetid=val;
       var dt= this.$store.state.bhusers.qarealst.sAreas;
     dt.forEach(item=>{
        if(item.id==val){
         this.sarealst=item;
        }
    })
      }
     CAreaChange(val:number){
         this.pagerequest.Comid=val;
       var dt= this.$store.state.bhusers.sarealst.cAreas;
    dt.forEach(item=>{
    if(item.id==val){
         this.carealst=item;
        }
    })
   }
   VAreaChange(val:number){
         this.pagerequest.Vid=val;
        
   }
  create() {}

     
  pageChange(page: number) {
    this.$store.commit("integral/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("integral/setPageSize", pagesize);
    this.getpage();
  }

 async getAreaAll() {
    await this.$store.dispatch({
      type: "bhusers/getQAreaAllData",
    });
  }
   isConsumptionType(val: number) {
       this.pagerequest.ConsumptionType=val;
  }
  isSourceType(val: number) {
       this.pagerequest.SourceType=val;
  }
  
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    if (this.creationTime.length > 0) {
      this.pagerequest.stime = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.etime = this.creationTime[1];
    }


    await this.$store.dispatch({
      type: "integral/getAll",
      data: this.pagerequest,
    });
  }

  get pageSize() {
    return this.$store.state.integral.pageSize;
  }
  get totalCount() {
    return this.$store.state.integral.totalCount;
  }
  get currentPage() {
    return this.$store.state.integral.currentPage;
  }

  columns = [
    {
      title: this.L("UserName"),

      render: (h: any, params: any) => {
        return h("span", params.row.bhUsers.username);
      },
    },
     //积分类型 1  可回收积分(蓝) 2易腐垃圾积分(绿)  3.其他积分
    {
      title: this.L("卡号"),
      render: (h: any, params: any) => {
            let code=params.row.bhUsers.qrcode;
          /*  switch(params.row.consumptionType)  {
     case 1:
     code=params.row.bhUsers.kitchenResidueCard;
     break;
       case 2:
    code=params.row.bhUsers.qrcode;
     break;
       case 3:
             code=params.row.bhUsers.otherCard;
         break;

     }*/


        return h("span",code );
      },
    },
     {
      title: this.L("地址"),
      render: (h: any, params: any) => {
            let useraddr=params.row.bhUsers.useraddr;
            


        return h("span",useraddr );
      },
    },
  //积分类型 1  可回收积分(蓝) 2易腐垃圾积分(绿)  3.其他积分
    {
      title: this.L("积分类型"),
      render: (h: any, params: any) => {
            let consumptionTypetxt="";
            let  sourceType=params.row.sourceType;
            switch(sourceType)  {
     case 1:
     consumptionTypetxt="可回收积分(蓝)";
     break;
       case 2:
     consumptionTypetxt="易腐垃圾积分(绿)";
     break;
       case 3:
      consumptionTypetxt="其他积分";
         break;

            }


        return h("span",consumptionTypetxt );
      },
    },
    

    {
      title: this.L("操作之前卡上积分"),
      key: "beforeSources",
    },
     
    {
      title: this.L("积分"),
      render: (h: any, params: any) => {
            let consumptionTypetxt="";
            let opt="";
            let  consumptionType=params.row.consumptionType;
            switch(consumptionType)  {
     case 0:
     opt="+";
     break;
       case 1:
     opt="-";
     break;
     
     }
            consumptionTypetxt= opt+ params.row.score;

        return h("span",consumptionTypetxt );
      },
    },
    {
      title: this.L("操作之后卡上积分"),
      key: "afterSources",
    },

     {
      title: this.L("操作来源"),
      key: "sources",
    },
     

     

    {
      title: this.L("时间"),
   
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.createTime).toLocaleString());
      },
    },

   
  ];
  async created() {
    this.getpage();
    this.getAreaAll();
  }
}
